import React, { Component } from "react"
import ButtonsForm from "../../../components/ButtonsForm"
import { Link, Redirect } from 'react-router-dom'
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import helper from "../../../utils/helper"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import General from "./general"
import JoinOtaaAbp from "./joinOtaaAbp"
import ClassB from "./classB"
import ClassC from "./classC"
import Relay from "./relay"
import Codec from "./codec"

import { getClientesModulo, getCliente, createOptionsClientes, getOptionCliente } from "../../../services/clientes"

class Form extends Component {
    userInfo = auth.getUserInfo()
    isCustomer = auth.isClient()

    state = {

        detalhesGeneral: {
            cliente: this.isCustomer ? { label: this.userInfo.nome, value: this.userInfo.cliente } : { label:"Nenhum", value: null },
            name: null,
            description: null,
            region: null,
            region_config_id: null,
            mac_version: null,
            reg_params_revision: null,
            adr_algorithm_id: null,
            flush_queue_on_activate: true,
            allow_roaming: false,
            uplink_interval: 3600,
            device_status_req_interval: 1,
            rx1_delay: 0
        },

        detalhesJoinOtaaAbp: {
            supports_otaa: true,
            abp_rx1_delay: 0,
            abp_rx1_dr_offset: 0,
            abp_rx2_dr: 0,
            abp_rx2_freq: 0
        },

        detalhesClassB: {
            supports_class_b: false,
            class_b_timeout: 0,
            class_b_ping_slot_nb_k: null,
            class_b_ping_slot_dr: 0,
            class_b_ping_slot_freq: 0
        },

        detalhesClassC: {
            supports_class_c: false,
            class_c_timeout: 0
        },
        
        detalhesRelay: {
            is_relay: false,
            is_relay_ed: false,
            relay_enabled: false,
            relay_ed_relay_only: false,
            relay_default_channel_index: 0,
            relay_second_channel_freq: 0,
            relay_second_channel_dr: 0,
            relay_second_channel_ack_offset: null, 
            relay_cad_periodicity: null,
            relay_ed_activation_mode: null,
            relay_ed_smart_enable_level: null, 
            relay_ed_back_off: 0,
            relay_ed_uplink_limit_bucket_size: null,
            relay_ed_uplink_limit_reload_rate: 0,
            relay_join_req_limit_bucket_size: null,
            relay_join_req_limit_reload_rate: 0,
            relay_notify_limit_bucket_size: null,
            relay_notify_limit_reload_rate: 0,
            relay_global_uplink_limit_bucket_size: null, 
            relay_global_uplink_limit_reload_rate: 0,
            relay_overall_limit_bucket_size: null,
            relay_overall_limit_reload_rate: 0
        },

        detalhesCodec: {
            payload_codec_runtime: 'JS',
            payload_codec_script: null,
        },

        errorsFields: {},

        cooldown: false,
        redirect: false,
        path: "",
        tab: 0,
        optionsSelect: { 
            region: [], 
            region_config_id: [], 
            mac_version: [], 
            reg_params_revision: [], 
            adr_algorithm_id: [], 
            class_b_ping_slot_nb_k: [], 
            relay_second_channel_ack_offset: [],
            relay_cad_periodicity: [],
            relay_ed_activation_mode: [],
            relay_ed_smart_enable_level: [],
            relay_ed_uplink_limit_bucket_size: [],
            relay_global_uplink_limit_bucket_size: [],
            relay_join_req_limit_bucket_size: [],
            relay_notify_limit_bucket_size: [],
            relay_overall_limit_bucket_size: []
        },

        optionsCliente: [ { label:"Nenhum", value: null } ]
    }

    get deviceProfileId() {
        if (this.props.isQuickRegister && this.props.deviceProfileId) {
            return this.props.deviceProfileId;
        }

        return this.props?.match?.params?.id;
    }

    componentDidMount = async () => {
        await this.getOptionsSelectGeneral()
        const clientesModulo = await getClientesModulo('lns')
        const optionsCliente = [...this.state.optionsCliente, ...createOptionsClientes(clientesModulo)]
        this.setState({ optionsCliente })

        if (this.props.templateProfile) {
            this.applyTemplateProfile(this.props.templateProfile)
        }

        if (this.deviceProfileId) {
            this.getData()
        } else if (this.props.lockedClienteId !== undefined) {
            const cliente = getOptionCliente(optionsCliente, this.props.lockedClienteId) ?? { label: "Nenhum", value: null }
            this.setState((prevState) => ({
                detalhesGeneral: { ...prevState.detalhesGeneral, cliente }
            }))
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.templateProfile && this.props.templateProfile !== prevProps.templateProfile) {
            this.applyTemplateProfile(this.props.templateProfile)
        }
    }

    getOptionsSelectGeneral = async () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/selects/informations/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        return axios.get(requestURL, config_me).then((res) => {
            const data = res.data

            this.setState({ 
                optionsSelect: { 
                    region: data.region, 
                    region_config_id: [],
                    mac_version: data.mac_version , 
                    reg_params_revision: data.reg_params_revision, 
                    adr_algorithm_id: data.adr_algorithm_id, 
                    class_b_ping_slot_nb_k: data.class_b_ping_slot_nb_k, 
                    relay_second_channel_ack_offset: data.relay_second_channel_ack_offset, 
                    relay_cad_periodicity: data.relay_cad_periodicity, 
                    relay_ed_activation_mode: data.relay_ed_activation_mode, 
                    relay_ed_smart_enable_level: data.relay_ed_smart_enable_level, 
                    relay_ed_uplink_limit_bucket_size: data.relay_ed_uplink_limit_bucket_size, 
                    relay_global_uplink_limit_bucket_size: data.relay_global_uplink_limit_bucket_size, 
                    relay_join_req_limit_bucket_size: data.relay_join_req_limit_bucket_size, 
                    relay_notify_limit_bucket_size: data.relay_notify_limit_bucket_size, 
                    relay_overall_limit_bucket_size: data.relay_overall_limit_bucket_size
                }
            })
        })
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/device/profile/' + this.deviceProfileId + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            this.setDetalhesGeneral(data)
            this.setDetalhesJoinOtaaAbp(data)
            this.setDetalhesClassB(data)
            this.setDetalhesClassC(data)
            this.setDetalhesRelay(data)
            this.setDetalhesCodec(data)
        })
    }

    applyTemplateProfile = (data) => {
        this.setDetalhesGeneral(data)
        this.setDetalhesJoinOtaaAbp(data)
        this.setDetalhesClassB(data)
        this.setDetalhesClassC(data)
        this.setDetalhesRelay(data)
        this.setDetalhesCodec(data)
    }

    setDetalhesGeneral = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesGeneral)
        const optionsSelect = Object.assign({}, this.state.optionsSelect)

        const region = optionsSelect.region.filter((item) => item.value === data.region)[0]
        optionsSelect["region_config_id"] = region?.region_config_id

        detalhes.cliente = getOptionCliente(this.state.optionsCliente, data.cliente) ?? { label:"Nenhum", value: null }
        detalhes.name = data.name
        detalhes.description = data.description
        detalhes.region = region
        detalhes.region_config_id = optionsSelect.region_config_id.filter((item) => item.value === data.region_config_id)[0]
        detalhes.mac_version = optionsSelect.mac_version.filter((item) => item.value === data.mac_version)[0]
        detalhes.reg_params_revision = optionsSelect.reg_params_revision.filter((item) => item.value === data.reg_params_revision)[0]
        detalhes.adr_algorithm_id = optionsSelect.adr_algorithm_id.filter((item) => item.value === data.adr_algorithm_id)[0]
        detalhes.flush_queue_on_activate = data.flush_queue_on_activate
        detalhes.allow_roaming = data.allow_roaming
        detalhes.uplink_interval = data.uplink_interval
        detalhes.device_status_req_interval = data.device_status_req_interval
        detalhes.rx1_delay = data.rx1_delay

        this.setState({detalhesGeneral: detalhes, optionsSelect})
    }

    setDetalhesJoinOtaaAbp = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesJoinOtaaAbp)

        detalhes.supports_otaa = data.supports_otaa

        if(data.supports_otaa === false) {
            detalhes.abp_rx1_delay = data.abp_rx1_delay 
            detalhes.abp_rx1_dr_offset = data.abp_rx1_dr_offset 
            detalhes.abp_rx2_dr = data.abp_rx2_dr 
            detalhes.abp_rx2_freq = data.abp_rx2_freq 
        }

        this.setState({detalhesJoinOtaaAbp: detalhes})
    }

    setDetalhesClassB = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesClassB)
        const optionsSelect = Object.assign({}, this.state.optionsSelect)
        
        detalhes.supports_class_b = data.supports_class_b

        if(data.supports_class_b) {
            detalhes.class_b_timeout = data.class_b_timeout 
            detalhes.class_b_ping_slot_nb_k = optionsSelect.class_b_ping_slot_nb_k.filter((item) => item.value === data.class_b_ping_slot_nb_k)[0]
            detalhes.class_b_ping_slot_dr = data.class_b_ping_slot_dr 
            detalhes.class_b_ping_slot_freq = data.class_b_ping_slot_freq 
        }

        this.setState({detalhesClassB: detalhes})
    }

    setDetalhesClassC = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesClassC)

        detalhes.supports_class_c = data.supports_class_c

        if(data.supports_class_c) {
            detalhes.class_c_timeout = data.class_c_timeout
        }

        this.setState({detalhesClassC: detalhes})
    }

    setDetalhesRelay = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesRelay)
        const optionsSelect = Object.assign({}, this.state.optionsSelect)

        detalhes.is_relay = data.is_relay
        detalhes.is_relay_ed = data.is_relay_ed

        if(data.is_relay || data.is_relay_ed) {
            detalhes.relay_default_channel_index = data.relay_default_channel_index 
            detalhes.relay_second_channel_freq = data.relay_second_channel_freq 
            detalhes.relay_second_channel_dr = data.relay_second_channel_dr 
            detalhes.relay_second_channel_ack_offset = optionsSelect.relay_second_channel_ack_offset.filter((item) => item.value === data.relay_second_channel_ack_offset)[0]
        }

        if(data.is_relay) {
            detalhes.relay_enabled = data.relay_enabled
            detalhes.relay_cad_periodicity = optionsSelect.relay_cad_periodicity.filter((item) => item.value === data.relay_cad_periodicity)[0]
            detalhes.relay_join_req_limit_bucket_size = optionsSelect.relay_join_req_limit_bucket_size.filter((item) => item.value === data.relay_join_req_limit_bucket_size)[0]
            detalhes.relay_join_req_limit_reload_rate = data.relay_join_req_limit_reload_rate
            detalhes.relay_notify_limit_bucket_size = optionsSelect.relay_notify_limit_bucket_size.filter((item) => item.value === data.relay_notify_limit_bucket_size)[0]
            detalhes.relay_notify_limit_reload_rate = data.relay_notify_limit_reload_rate
            detalhes.relay_global_uplink_limit_bucket_size = optionsSelect.relay_global_uplink_limit_bucket_size.filter((item) => item.value === data.relay_global_uplink_limit_bucket_size)[0]
            detalhes.relay_global_uplink_limit_reload_rate = data.relay_global_uplink_limit_reload_rate
            detalhes.relay_overall_limit_bucket_size = optionsSelect.relay_overall_limit_bucket_size.filter((item) => item.value === data.relay_overall_limit_bucket_size)[0]
            detalhes.relay_overall_limit_reload_rate = data.relay_overall_limit_reload_rate
        }

        if(data.is_relay_ed) {
            detalhes.relay_ed_relay_only = data.relay_ed_relay_only
            detalhes.relay_ed_activation_mode = optionsSelect.relay_ed_activation_mode.filter((item) => item.value === data.relay_ed_activation_mode)[0]
            detalhes.relay_ed_smart_enable_level = optionsSelect.relay_ed_smart_enable_level.filter((item) => item.value === data.relay_ed_smart_enable_level)[0]
            detalhes.relay_ed_back_off = data.relay_ed_back_off
            detalhes.relay_ed_uplink_limit_bucket_size = optionsSelect.relay_ed_uplink_limit_bucket_size.filter((item) => item.value === data.relay_ed_uplink_limit_bucket_size)[0]
            detalhes.relay_ed_uplink_limit_reload_rate = data.relay_ed_uplink_limit_reload_rate
        }

        this.setState({detalhesRelay: detalhes})
    }

    setDetalhesCodec = (data) => {
        const detalhes = Object.assign({}, this.state.detalhesCodec)

        detalhes.payload_codec_script = data.payload_codec_script

        this.setState({detalhesCodec: detalhes})
    }

    handleQuickRegister = async () => {
        return new Promise((resolve) => {
            this.saveAction(false, resolve);
        });
    };

    saveAction = (novoCadastro, resolve = null) => {
        const { detalhesGeneral, detalhesJoinOtaaAbp, detalhesClassB, detalhesClassC, detalhesRelay, detalhesCodec } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""
        const deviceProfileId = this.deviceProfileId

        if (deviceProfileId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/device/profile/' + deviceProfileId + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/device/profile/'
            verb = 'post'
        }

        const data = {}

        data["cliente_id"] = detalhesGeneral.cliente.value
        data["name"] = detalhesGeneral.name ?? ""
        data["description"] = detalhesGeneral.description ?? ""
        data["region"] = detalhesGeneral.region?.value ?? ""
        data["region_config_id"] = detalhesGeneral.region_config_id?.value ?? ""
        data["mac_version"] = detalhesGeneral.mac_version?.value ?? ""
        data["reg_params_revision"] = detalhesGeneral.reg_params_revision?.value ?? ""
        data["adr_algorithm_id"] = detalhesGeneral.adr_algorithm_id?.value ?? ""
        data["flush_queue_on_activate"] = detalhesGeneral.flush_queue_on_activate ?? ""
        data["allow_roaming"] = detalhesGeneral.allow_roaming ?? ""
        data["uplink_interval"] = detalhesGeneral.uplink_interval ?? ""
        data["device_status_req_interval"] = detalhesGeneral.device_status_req_interval ?? ""
        data["rx1_delay"] = detalhesGeneral.rx1_delay ?? 0

        data["supports_otaa"] = detalhesJoinOtaaAbp.supports_otaa ?? ""

        if(detalhesJoinOtaaAbp.supports_otaa === false) {
            data["abp_rx1_delay"] = detalhesJoinOtaaAbp.abp_rx1_delay ?? ""
            data["abp_rx1_dr_offset"] = detalhesJoinOtaaAbp.abp_rx1_dr_offset ?? ""
            data["abp_rx2_dr"] = detalhesJoinOtaaAbp.abp_rx2_dr ?? ""
            data["abp_rx2_freq"] = detalhesJoinOtaaAbp.abp_rx2_freq ?? ""
        }

        data["supports_class_b"] = detalhesClassB.supports_class_b ?? ""

        if(detalhesClassB.supports_class_b) {
            data["class_b_timeout"] = detalhesClassB.class_b_timeout ?? ""
            data["class_b_ping_slot_nb_k"] = detalhesClassB.class_b_ping_slot_nb_k?.value ?? ""
            data["class_b_ping_slot_dr"] = detalhesClassB.class_b_ping_slot_dr ?? ""
            data["class_b_ping_slot_freq"] = detalhesClassB.class_b_ping_slot_freq ?? ""
        }

        data["supports_class_c"] = detalhesClassC.supports_class_c ?? ""

        if(detalhesClassC.supports_class_c) {
            data["class_c_timeout"] = detalhesClassC.class_c_timeout ?? ""
        }

        data["is_relay"] = detalhesRelay.is_relay ?? ""
        data["is_relay_ed"] = detalhesRelay.is_relay_ed ?? ""

        if(detalhesRelay.is_relay || detalhesRelay.is_relay_ed) {
            data["relay_default_channel_index"] = detalhesRelay.relay_default_channel_index ?? ""
            data["relay_second_channel_freq"] = detalhesRelay.relay_second_channel_freq ?? ""
            data["relay_second_channel_dr"] = detalhesRelay.relay_second_channel_dr ?? ""
            data["relay_second_channel_ack_offset"] = detalhesRelay.relay_second_channel_ack_offset?.value ?? ""
        }

        if(detalhesRelay.is_relay) {
            data["relay_enabled"] = detalhesRelay.relay_enabled ?? ""
            data["relay_cad_periodicity"] = detalhesRelay.relay_cad_periodicity?.value ?? ""
            data["relay_join_req_limit_bucket_size"] = detalhesRelay.relay_join_req_limit_bucket_size?.value ?? ""
            data["relay_join_req_limit_reload_rate"] = detalhesRelay.relay_join_req_limit_reload_rate ?? ""
            data["relay_notify_limit_bucket_size"] = detalhesRelay.relay_notify_limit_bucket_size?.value ?? ""
            data["relay_notify_limit_reload_rate"] = detalhesRelay.relay_notify_limit_reload_rate ?? ""
            data["relay_global_uplink_limit_bucket_size"] = detalhesRelay.relay_global_uplink_limit_bucket_size?.value ?? ""
            data["relay_global_uplink_limit_reload_rate"] = detalhesRelay.relay_global_uplink_limit_reload_rate ?? ""
            data["relay_overall_limit_bucket_size"] = detalhesRelay.relay_overall_limit_bucket_size?.value ?? ""
            data["relay_overall_limit_reload_rate"] = detalhesRelay.relay_overall_limit_reload_rate ?? ""
        }

        if(detalhesRelay.is_relay_ed) {
            data["relay_ed_relay_only"] = detalhesRelay.relay_ed_relay_only ?? ""
            data["relay_ed_activation_mode"] = detalhesRelay.relay_ed_activation_mode?.value ?? ""
            data["relay_ed_smart_enable_level"] = detalhesRelay.relay_ed_smart_enable_level?.value ?? ""
            data["relay_ed_back_off"] = detalhesRelay.relay_ed_back_off ?? ""
            data["relay_ed_uplink_limit_bucket_size"] = detalhesRelay.relay_ed_uplink_limit_bucket_size?.value ?? ""
            data["relay_ed_uplink_limit_reload_rate"] = detalhesRelay.relay_ed_uplink_limit_reload_rate ?? ""
        }

        data["payload_codec_runtime"] = detalhesCodec.payload_codec_runtime ?? ""
        data["payload_codec_script"] = detalhesCodec.payload_codec_script ?? ""

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                helper.dispatchEvent("showAviso", {
                    message: `Perfil ${verb === "post" ? "criado" : "editado"} com sucesso.`,
                    callback: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) resolve({
                                success: true,
                                deviceProfileId: res.data.id
                            });
                            return
                        }

                        this.setState({ redirect: true, path: "/lns/device/profile" })
                    },
                    callbackClose: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) resolve({
                                success: true,
                                deviceProfileId: res.data.id
                            });
                            return
                        };
                        if (verb === "post") {
                            window.location.href = `/lns/device/profile/${res.data.id}/editar`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                    }
                })
            }
        }).catch((error) => {
            if (resolve) resolve({
                success: false
            });

            const errorsFields = Object.assign({}, this.state.errorsFields)
            let erros = Object.entries(error.response.data)

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    errorsFields[erros[i][0]] = erros[i][1][0]
                }
            }

            this.setState({ errorsFields })
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleTab = (index) => this.setState({ tab: index })
    
    render() {
        const { detalhesGeneral, detalhesJoinOtaaAbp, detalhesClassB, detalhesClassC, detalhesRelay, detalhesCodec, optionsSelect, errorsFields, optionsCliente } = this.state
        const edit = this.props?.match?.params?.id ? true : false
        const { isTemplate, closeModal, importProfile, isLoadingImport } = this.props

        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }

        return (
            <div>
                {!this.props.isQuickRegister &&
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            {(!this.props.isQuickRegister && !isTemplate) &&
                                <i
                                    className="fa fa-info-circle fa-20px"
                                    title='Informações do Cadastro de Aplicações'
                                    style={{
                                        cursor: "pointer",
                                        marginRight: '5px',
                                        marginTop: '10px',
                                    }}
                                    onClick={() =>
                                        helper.dispatchEvent("showAviso", {
                                            message: `
                                                Define como o dispositivo opera dentro do protocolo LoRa. Crie um perfil para cada linha de dispositivos que você utiliza.<br /><br />
                                                Antes de criar o perfil, identifique o método de autenticação do seu dispositivo:<br /><br />
                                                <strong>OTAA (recomendado)</strong> — O dispositivo negocia as chaves com a rede automaticamente. Você precisará do <strong>DevEUI</strong>, <strong>AppEUI</strong> e <strong>AppKey</strong>.<br /><br />
                                                <strong>ABP</strong> — As chaves são fixas e gravadas diretamente no dispositivo. Você precisará do <strong>DevAddr</strong>, <strong>NwkSKey</strong> e <strong>AppSKey</strong>.<br /><br />
                                                ⚠️ O método escolhido aqui deve ser o mesmo configurado no hardware, pois as chaves exigidas no cadastro mudam conforme o tipo.
                                            `,
                                        })
                                    }
                                />

                            }
                            {!isTemplate && (
                                <>
                                    {this.props?.match?.params?.id ? (
                                        <h4>Editar Perfil</h4>
                                    ) : (
                                        <h4>Novo Perfil</h4>
                                    )}
                                    <div className="gray-background">
                                        <i className="las fa-hdd la-2x"></i>
                                    </div>
                                </>
                            )}
                        </span>
                    </div>
                }

                <Tabs className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab>Geral</Tab>
                        <Tab>Ligar (OTAA / ABP)</Tab>
                        <Tab>Classe B</Tab>
                        <Tab>Classe C</Tab>
                        <Tab>Relé</Tab>
                        <Tab>Codec</Tab>
                    </TabList>
                    <TabPanel>
                        <General
                            detalhes={detalhesGeneral}
                            setDetalhes={(data) => this.setState({ detalhesGeneral: data })}
                            optionsSelect={optionsSelect}
                            setOptionsSelect={(data) => this.setState({ optionsSelect: data })}
                            optionsCliente={optionsCliente}
                            errors={errorsFields}
                            setErrors={(data) => this.setState({ errorsFields: data })}
                            edit={edit}
                            isTemplate={isTemplate}
                            lockedClienteId={this.props.lockedClienteId}
                        />
                    </TabPanel>
                    <TabPanel>
                        <JoinOtaaAbp
                            detalhes={detalhesJoinOtaaAbp}
                            setDetalhes={(data) => this.setState({ detalhesJoinOtaaAbp: data })}
                            errors={errorsFields}
                            setErrors={(data) => this.setState({ errorsFields: data })}
                            isTemplate={isTemplate}
                        />
                    </TabPanel>
                    <TabPanel>
                        <ClassB
                            detalhes={detalhesClassB}
                            setDetalhes={(data) => this.setState({ detalhesClassB: data })}
                            optionsSelect={optionsSelect}
                            errors={errorsFields}
                            setErrors={(data) => this.setState({ errorsFields: data })}
                            isTemplate={isTemplate}
                        />
                    </TabPanel>
                    <TabPanel>
                        <ClassC
                            detalhes={detalhesClassC}
                            setDetalhes={(data) => this.setState({ detalhesClassC: data })}
                            errors={errorsFields}
                            setErrors={(data) => this.setState({ errorsFields: data })}
                            isTemplate={isTemplate}
                        />
                    </TabPanel>
                    <TabPanel>
                        <Relay
                            detalhes={detalhesRelay}
                            setDetalhes={(data) => this.setState({ detalhesRelay: data })}
                            optionsSelect={optionsSelect}
                            errors={errorsFields}
                            setErrors={(data) => this.setState({ errorsFields: data })}
                            isTemplate={isTemplate}
                        />
                    </TabPanel>
                    <TabPanel>
                        <Codec
                            value={detalhesCodec.payload_codec_script}
                            setValue={(data) => this.setState({ detalhesCodec: { ...detalhesCodec, payload_codec_script: data } })}
                            isTemplate={isTemplate}
                        />
                    </TabPanel>
                </Tabs>

                {!this.props.isQuickRegister &&
                    <div className="hdv-btn-group">
                        {!isTemplate ?
                            <>
                                <ButtonsForm
                                    route="/lns/device/profile"
                                    edit={this.props?.match?.params?.id ? true : false}
                                    cooldown={this.state.cooldown}
                                    buttons={[
                                        {
                                            method: "post",
                                            button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                        },

                                        {
                                            method: "post",
                                            button: <button style={{ display: this.props?.match?.params?.id ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                                        },

                                        {
                                            method: "patch",
                                            button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                        },
                                    ]}
                                />
                                <Link to="/lns/device/profile">
                                    <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                                </Link>
                            </>
                            :
                            <>
                                <button
                                    onClick={importProfile}
                                    className="hdv-btn-forms hdv-btn-green"
                                    disabled={isLoadingImport}
                                >
                                    Importar
                                </button>
                                <button
                                    onClick={closeModal}
                                    className="hdv-btn-forms hdv-btn-orange"
                                    disabled={isLoadingImport}
                                >
                                    Cancelar
                                </button>
                            </>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default Form